export default __webpack_public_path__ + "img/fff4013fd27422e3cad9ab0df6b347da.png";